// A part adjustment type that is neither scrap nor correction is treated by
// the API as a manual part-count adjustment (raw part-count stream) rather
// than a reject. Only the built-in (null-company) reason qualifies here:
// company-created reasons are always scrap:true via the API, and a legacy
// company row with odd flags must keep today's reject behavior.
const isManualAdjustmentType = (partAdjustmentType) => {
  return (
    !!partAdjustmentType &&
    partAdjustmentType.companyId == null &&
    !partAdjustmentType.scrap &&
    !partAdjustmentType.correction
  );
};

// Company-created reasons are always shown; global (null-company) reasons are
// limited to the manual-adjustment type, and only when the feature is enabled.
const filterPartAdjustmentTypes = (
  partAdjustmentTypes,
  includeManualAdjustment
) => {
  return partAdjustmentTypes.filter((partAdjustmentType) => {
    if (partAdjustmentType.companyId != null) return true;
    return (
      includeManualAdjustment && isManualAdjustmentType(partAdjustmentType)
    );
  });
};

const buildRejectPartsPayload = ({
  parts,
  category,
  notes,
  type,
  removeFromGoodParts,
  machineId,
}) => {
  if (isManualAdjustmentType(category)) {
    return {
      count: -parts,
      machine_id: machineId,
      category_id: category.id,
      message: notes || null,
    };
  }

  return {
    scrapcount: parts,
    machine_id: machineId,
    count: removeFromGoodParts ? 0 : parts,
    reject_behavior: type,
    category_id: category.id,
    message: notes || null,
  };
};

export {
  isManualAdjustmentType,
  filterPartAdjustmentTypes,
  buildRejectPartsPayload,
};
